import {Space} from "antd";
import {SessionSubGenInfoFormFieldsProps} from "./types";
import {SessionSubGenInfoNameFormField} from "./name-form-field";
import {SessionSubGenInfoDescriptionFormField} from "./description-form-field";

export function SessionSubGenInfoFormFields({
  nameFieldId,
  nameFieldLabel,
  nameFieldPlaceholder,
  descriptionFieldId,
  descriptionFieldLabel,
  descriptionFieldPlaceholder,
  coverImageFieldId,
  coverImageFieldLabel,
  coverImageFieldPlaceholder,
}: SessionSubGenInfoFormFieldsProps) {
  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <SessionSubGenInfoNameFormField
          id={nameFieldId}
          label={nameFieldLabel}
          placeholder={nameFieldPlaceholder}
        />
        <SessionSubGenInfoDescriptionFormField
          id={descriptionFieldId}
          label={descriptionFieldLabel}
          placeholder={descriptionFieldPlaceholder}
        />
      </Space>
    </div>
  );
}
